import router from '@/router'
export function getPromiseAction(p, commit, mutationType){
  let promise = new Promise((resolve, reject) => {
    p.then(
      res => {
        let {status, data} = res.response ? res.response : res
        if (!data) {
          return reject({code:status, message: res})
        } else if (status === 200) {
          commit(mutationType, data)
          return resolve(data)
        } else if (status === 401) {
//          localStorage.removeItem('token')
//          sessionStorage.setItem('last-error', data.error.message)
//          router.push({path: '/'})
          return reject(data)
        } else {
          return reject(data)
        }
      },
      error => {
        return reject (
          {code:0, message: `数据加载失败，请重试, ${error}`}
        )
      }
    ).catch(
      error => {
        return reject (
          {code:0, message: `数据请求异常，请重试, ${error}`}
        )
      }
    )
  })
  return promise
}

export function getPromiseActionNoMutations(p){
  let promise = new Promise((resolve, reject) => {
    p.then( res => {
      let {status, data} = res.response ? res.response : res
      if (!data) {
        return reject({code:status, message: res})
      } else if (status === 200) {
        return resolve(data)
      } else if (status === 401) {
//	      localStorage.removeItem('token')
//        sessionStorage.setItem('last-error', data.error.message)
//        router.push({path: '/'})
      } else {
        return reject(data)
      }
    }, error => {
      return reject(
       {code:0,message:`数据加载失败，请重试,${error}`}
      )
    }).catch( error => {
      return reject(
        {code:0,message:`数据请求异常，请重试,${error}`}
      )
    })
  })
  return promise
}



// WEBPACK FOOTER //
// ./src/utils/promiseUtils.js